// extracted by mini-css-extract-plugin
export var terms = "terms-module--terms--2fc5e";
export var terms__detail = "terms-module--terms__detail--736e8";
export var terms__links = "terms-module--terms__links--551a2";
export var terms__sort = "terms-module--terms__sort--b1509";
export var terms__term = "terms-module--terms__term--a1793";
export var terms__term_selected = "terms-module--terms__term_selected--54168";